var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('div',{ref:"loginContainer",attrs:{"id":"ding_login_container"}}),_vm._v(" "),(_vm.isAuth)?_c('div',[_c('Spin',{attrs:{"fix":""}}),_vm._v("\n    扫描成功...\n  ")],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277439b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sing-in/ding-auth.vue
// module id = null
// module chunks = 